/* ==========================================================================
   Speedometer Calibration Calculator
   Self-contained. Loaded only on this calculator's page.
   No shared dependencies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-pc-spc]');
  if (!root) return;

  var INCHES_PER_MILE = 63360;
  /* Constant in the classic GM speedometer gear formula. */
  var GEAR_CONSTANT = 1001;

  /* ====================================================================
     compute(input) -> result

     PURE. No DOM, no network, no globals. All calculator logic lives here
     so it can be reasoned about and tested in isolation.
     ==================================================================== */
  function compute(input) {
    var need = ['oldDia','newDia','oldAxle','newAxle'];
    for (var i = 0; i < need.length; i++) {
      if (!isFinite(input[need[i]]) || input[need[i]] <= 0) {
        return { ok: false, errors: ['Fill in both tire diameters and both axle ratios.'] };
      }
    }
    var indicated = isFinite(input.indicated) && input.indicated > 0 ? input.indicated : 60;

    /* The speedometer counts driveshaft revolutions and was calibrated for the
       original tire and gear. Taller tires travel further per revolution, and
       numerically higher gears spin the shaft faster. */
    var factor = (input.newDia / input.oldDia) * (input.oldAxle / input.newAxle);
    var actual = indicated * factor;
    var errorPct = (factor - 1) * 100;

    var status;
    var absErr = Math.abs(errorPct);
    if (absErr < 1) {
      status = { key: 'good', label: 'Within 1%',
                 note: 'No meaningful error. Nothing to correct.' };
    } else if (absErr < 3) {
      status = { key: 'good', label: signed(errorPct, 1) + '%',
                 note: 'Small enough that most people would not bother correcting it.' };
    } else if (absErr < 8) {
      status = { key: 'soon', label: signed(errorPct, 1) + '%',
                 note: 'Noticeable. At an indicated ' + num(indicated, 0) + ' you are actually doing ' + num(actual, 1) + '.' };
    } else {
      status = { key: 'now', label: signed(errorPct, 1) + '%',
                 note: 'Large error. Your odometer and every trip computer figure are wrong by the same amount.' };
    }

    var rows = [
      { head: 'Error' },
      { label: 'Correction factor', value: num(factor, 4) },
      { label: 'Speedometer error', value: signed(errorPct, 2) + '%' },
      { label: 'Reads ' + num(indicated, 0), value: 'actually ' + num(actual, 1) + ' mph' },
      { head: 'At other speeds' }
    ];
    [25, 35, 45, 55, 65, 75].forEach(function (s) {
      rows.push({ label: 'Indicated ' + s, value: 'actual ' + num(s * factor, 1) });
    });
    rows.push({ head: 'Odometer' });
    rows.push({ label: 'Shows 100 miles', value: 'you drove ' + num(100 * factor, 1) });
    rows.push({ label: 'Per 10,000 miles', value: signed((factor - 1) * 10000, 0) + ' miles unrecorded' });

    var figures = [
      { label: 'Actual speed', value: num(actual, 1) + ' mph',
        sub: 'When the speedometer reads ' + num(indicated, 0) + '. Error of ' + signed(errorPct, 1) + '%.' },
      { label: 'Correction factor', value: num(factor, 4),
        sub: 'Multiply any indicated reading by this to get the true value.' }
    ];

    var warnings = [];
    if (isFinite(input.driveTeeth) && input.driveTeeth > 0) {
      var revsPerMile = INCHES_PER_MILE / (Math.PI * input.newDia);
      var driven = (revsPerMile * input.newAxle * input.driveTeeth) / GEAR_CONSTANT;
      rows.push({ head: 'Cable driven speedometer' });
      rows.push({ label: 'Tire revs per mile', value: num(revsPerMile, 0) });
      rows.push({ label: 'Drive gear teeth', value: num(input.driveTeeth, 0) });
      rows.push({ label: 'Driven gear needed', value: num(driven, 1) + ' teeth' });
      rows.push({ label: 'Fit', value: num(Math.round(driven), 0) + ' tooth gear' });
      figures.push({ label: 'Driven gear', value: num(Math.round(driven), 0) + ' teeth',
        sub: 'Calculated ' + num(driven, 1) + '. Gears only come in whole teeth, so pick the nearest.' });
      if (Math.abs(driven - Math.round(driven)) > 0.4) {
        warnings.push('The exact figure is ' + num(driven, 1) + ' teeth, which is halfway between available gears. You may need a ratio adapter housing to get it exact.');
      }
    } else if (absErr >= 3) {
      warnings.push('On an electronic speedometer this is corrected with a programmer or a recalibration module. On a cable driven setup you change the driven gear in the transmission tailshaft. Enter your drive gear tooth count above for that calculation.');
    }

    return { ok: true, errors: [], warnings: warnings, status: status, figures: figures, rows: rows };
  }

  /* ====================================================================
     Formatting
     ==================================================================== */
  function comma(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n, dp) {
    if (!isFinite(n)) return '-';
    var v = Number(n).toFixed(dp == null ? 2 : dp);
    if (dp !== 0 && v.indexOf('.') > -1) v = v.replace(/\.?0+$/, '');
    var parts = v.split('.');
    return comma(parts[0]) + (parts[1] ? '.' + parts[1] : '');
  }

  function signed(n, dp) {
    if (!isFinite(n)) return '-';
    return (n > 0 ? '+' : '') + num(n, dp);
  }

  /* ====================================================================
     DOM wiring
     ==================================================================== */
  var FIELDS = [
      {
          "name": "oldDia",
          "key": "od",
          "type": "number"
      },
      {
          "name": "newDia",
          "key": "nd",
          "type": "number"
      },
      {
          "name": "oldAxle",
          "key": "oa",
          "type": "number"
      },
      {
          "name": "newAxle",
          "key": "na",
          "type": "number"
      },
      {
          "name": "indicated",
          "key": "i",
          "type": "number"
      },
      {
          "name": "driveTeeth",
          "key": "dt",
          "type": "number"
      }
  ];

  var els = {
    error:    root.querySelector('[data-r-error]'),
    status:   root.querySelector('[data-r-status]'),
    statusLbl:root.querySelector('[data-r-status-label]'),
    statusVal:root.querySelector('[data-r-status-value]'),
    statusNote:root.querySelector('[data-r-status-note]'),
    figures:  root.querySelector('[data-r-figures]'),
    rows:     root.querySelector('[data-r-rows]'),
    warnings: root.querySelector('[data-r-warnings]')
  };

  var STATUS_CLASSES = ['is-good','is-monitor','is-soon','is-now','is-critical'];

  function field(name) { return root.querySelector('[data-f="' + name + '"]'); }

  function readInput() {
    var o = {};
    FIELDS.forEach(function (f) {
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') o[f.name] = el.checked;
      else if (f.type === 'number') o[f.name] = parseFloat(el.value);
      else o[f.name] = el.value;
    });
    return o;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function renderFigures(figs) {
    els.figures.innerHTML = (figs || []).map(function (f) {
      return '<div class="pc-spc__figure">'
        + '<div class="pc-spc__figure-label">' + esc(f.label) + '</div>'
        + '<div class="pc-spc__figure-value' + (f.muted ? ' is-muted' : '') + '">'
        + esc(f.value) + '</div>'
        + (f.sub ? '<div class="pc-spc__figure-sub">' + esc(f.sub) + '</div>' : '')
        + '</div>';
    }).join('');
  }

  function renderRows(rows) {
    if (!els.rows) return;
    els.rows.innerHTML = (rows || []).map(function (r) {
      if (r.head) {
        return '<div class="pc-spc__row pc-spc__rows-head">' + esc(r.head) + '</div>';
      }
      return '<div class="pc-spc__row">'
        + '<span class="pc-spc__row-label">' + esc(r.label) + '</span>'
        + '<span class="pc-spc__row-value">' + esc(r.value) + '</span>'
        + '</div>';
    }).join('');
  }

  function clearResult(message) {
    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      els.statusVal.textContent  = 'Waiting for your numbers';
      els.statusNote.textContent = message || '';
    }
    els.figures.innerHTML = '';
    if (els.rows) els.rows.innerHTML = '';
    if (els.warnings) els.warnings.style.display = 'none';
  }

  function render() {
    var input  = readInput();
    var result = compute(input);

    if (!result.ok) {
      els.error.textContent = result.errors[0];
      els.error.classList.add('is-shown');
      clearResult(result.errors[0]);
      return;
    }
    els.error.classList.remove('is-shown');

    if (els.status) {
      STATUS_CLASSES.forEach(function (c) { els.status.classList.remove(c); });
      if (result.status) {
        els.status.classList.add('is-' + result.status.key);
        els.statusVal.textContent  = result.status.label;
        els.statusNote.textContent = result.status.note || '';
      } else {
        els.statusVal.textContent  = '';
        els.statusNote.textContent = '';
      }
    }

    renderFigures(result.figures);
    renderRows(result.rows);

    if (els.warnings) {
      if (result.warnings && result.warnings.length) {
        els.warnings.textContent = result.warnings[0];
        els.warnings.style.display = '';
      } else {
        els.warnings.style.display = 'none';
      }
    }

    writePermalink(input);
  }

  /* ====================================================================
     Shareable result permalinks
     ==================================================================== */
  function writePermalink(input) {
    if (!window.history || !window.history.replaceState) return;
    var q = FIELDS.map(function (f) {
      var v = input[f.name];
      if (f.type === 'checkbox') return v ? f.key + '=1' : '';
      if (v == null || v !== v || v === '') return '';
      return f.key + '=' + encodeURIComponent(v);
    }).filter(Boolean).join('&');
    try {
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : ''));
    } catch (e) {}
  }

  function applyPermalink() {
    if (!window.URLSearchParams) return;
    var p = new URLSearchParams(window.location.search);
    var any = false;
    FIELDS.forEach(function (f) {
      if (!p.has(f.key)) return;
      var el = field(f.name);
      if (!el) return;
      if (f.type === 'checkbox') el.checked = p.get(f.key) === '1';
      else el.value = p.get(f.key);
      any = true;
    });
    return any;
  }

  /* ====================================================================
     Init
     ==================================================================== */
  ['input', 'change'].forEach(function (evt) {
    root.addEventListener(evt, function (e) {
      if (e.target.closest('[data-r-form]')) render();
    });
  });

  applyPermalink();
  render();

  /* Exposed for testing and debugging only. */
  window.PC_SPC = { compute: compute };
})();
